import axios from "axios";
import {
    GET_ERRORS,
    USER_ADD,
    USER_UPDATE
} from "./types";
import * as myConstList from "./baseUrl"

const baseUrl = myConstList.baseUrl;

export const addBanner = (CryptoData, header) => dispatch => {
    axios
        .post(baseUrl + "/api/addBanner", CryptoData,header)
        .then(res =>
            dispatch({
                type: 'BANNER_ADD',
                payload: res,
            })
        ).catch(err =>
        dispatch({
            type: GET_ERRORS,
            payload: err.response.data
        })
    );
};


export const updateBanner = (CryptoData) => dispatch => {
    axios
        .post(baseUrl + "/api/banner-update", CryptoData)
        .then(res =>
            dispatch({
                type: 'BANNER_UPDATE',
                payload: res,
            })
        ).catch(err =>
        dispatch({
            type: GET_ERRORS,
            payload: err.response.data
        })
    );
};
